import React from 'react';
import "./Search.css";
import { ICONS } from '@ohif/ui';

const Search = ({ text, onSearchClick, enableRealTimeSearch = false, value, setValue }) => {
  const handleInputChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    if (enableRealTimeSearch) {
      onSearchClick(event.target.value);
    } else if (newValue === '') {
      onSearchClick('');
    }
  };

  const searchHandle = () => {
    onSearchClick(value);
  };

  const clear = () => {
    setValue('');
    onSearchClick('');
  };

  return (
    <div className='form-groupfield'>
      <input
        type='text'
        value={value}
        placeholder={text}
        onChange={handleInputChange}
      />
      {value && (
        <button onClick={clear} className='btnClear'>
          <img src={ICONS.closeSearch} />
        </button>
      )}
      <button onClick={searchHandle} className='btn'>
        <img src={ICONS.searchIcon} />
      </button>
    </div>
  );
};

export default Search;
